import { useEffect, useState } from "react";

import { formatNumber } from "../utils/numbers";

const endpoint =
  "https://mvo642fzvc.execute-api.us-east-1.amazonaws.com/dev/api/cliente";

export function useExchangeRate() {
  const [exchangeRate, setExchangeRate] = useState(null);
  useEffect(() => {
    fetch(endpoint)
      .then((response) => response.json())
      .then((json) => {
        let rate = json[0].valor;
        rate = formatNumber(Math.abs(rate), 3);
        setExchangeRate(rate);
      });
  }, []);
  return exchangeRate;
}
